import script from "./NotarialActionsItem.vue?vue&type=script&setup=true&lang=js"
export * from "./NotarialActionsItem.vue?vue&type=script&setup=true&lang=js"

import "./NotarialActionsItem.vue?vue&type=style&index=0&id=00be4284&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00be4284"]])

export default __exports__